import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators as bind} from 'redux';
import * as requestedStipsInfoActions from '../../../actions/requestedStipsInfoActions';
import {setFilesToBeUploaded} from '../../../actions/attachmentActions';
import FileUploader from '../FileUploader/FileUploader';
import StipsPreviewerAndTaggerTool from './StipsPreviewerAndTaggerTool';
import {trackMessage} from '@forwardfinancing/analytics-frontend-library';

export class StipsUploader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      failedUploads: [],
      previewerActive: false,
      filesForPreviewer: []
    };
  }

  handlePreviewerClose() {
    this.setState({
      previewerActive: false,
      filesForPreviewer: []
    });
  }

  renderPreviewerModal() {
    return(
      <StipsPreviewerAndTaggerTool
        {...this.props}
        isActive={this.state.previewerActive}
        files={this.state.filesForPreviewer}
        onClose={this.handlePreviewerClose.bind(this)}
        handleSetTag={this.updateFileTag.bind(this)}
        handleSetDescription={this.updateFileDescription.bind(this)}
        handleSetOwner={this.updateFileOwner.bind(this)}
        handleSetExpiration={this.updateFileExpiration.bind(this)}
        owners={this.props.owners}
      />
    );
  }

  handleFileDrop(files) {
    const { submissionDba, dba } = this.props;

    trackMessage({
      type: "Stip upload modal",
      messageInfo: {
        fileCount: files.length,
        fileTypes: files.map(file => file.type),
        dba: `${dba || submissionDba}`
      }
    });
    this.setState({
      previewerActive: true,
      filesForPreviewer: files
    });
  }

  updateFileTag(event, filePreview) {
    if (event) {
      let tagValue = event.target.value;
      this.props.requestedStipsInfoActions.setStipFileTag(filePreview, tagValue);
    }
  }

  updateFileDescription(description, filePreview) {
    this.props.requestedStipsInfoActions.setStipFileDescription(filePreview, description);
  }

  updateFileOwner(ownerUuid, filePreview) {
    this.props.requestedStipsInfoActions.setStipFileOwner(filePreview, ownerUuid);
  }

  updateFileExpiration(expiresOn, filePreview) {
    this.props.requestedStipsInfoActions.setStipFileExpiration(filePreview, expiresOn);
  }

  render() {
    return (
      <div className="stips-uploader">
        {this.renderPreviewerModal()}
        <FileUploader
          {...this.props}
          shouldRenderFilePreviewer={false}
          additionalOnDropAction={this.handleFileDrop.bind(this)}
        />
      </div>
    );
  }
}

StipsUploader.propTypes = {
  requestedStipsInfoActions: PropTypes.object,
  filesToBeUploaded: PropTypes.array,
  failedUploads: PropTypes.array,
  dba: PropTypes.string,
  submissionDba: PropTypes.string,
  owners: PropTypes.array,
  setFiles: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    submissionDba: state.submission.name,
    filesToBeUploaded: state.requestedStipsInfo.requestedStipsFormInfo.files,
    owners: state.requestedStipsInfo.owners
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setFiles: bind(setFilesToBeUploaded, dispatch),
    requestedStipsInfoActions: bind(requestedStipsInfoActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StipsUploader);
